<template>
  <div class="flex items-center px-2" :title="DroneIsCharging ? $e('Batterie en cours de charge') : ''">
    <svg class="w-5 mr-2 fill-current" :class="DroneIsCharging ? 'charging-batteri' : ''" viewBox="0 0 82 46"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.299988 0.900024V45.1H71.1V34.5H81.7V11.5H71.1V0.900024H0.299988ZM65.1 39.1H6.29999V6.90003H65.1V39.1ZM75.7 17.5V28.5H71.1V17.5H75.7Z" />
      <path class="b1" d="M21.1 14H15.1V32.08H21.1V14Z" />
      <path class="b2" d="M38.2 14H32.2V32.08H38.2V14Z" />
      <path class="b3" d="M55.2 14H49.2V32.08H55.2V14Z" />
    </svg>
    <template v-if="!DroneIsCharging">
      <span class="text-xs">
        {{ Batt1 }}%
        <span class="ml-1 mr-3 text-[10px]">({{ TempBatt1 }}°C)</span>
      </span>

      <span class="text-xs" v-if="Batt2 != false">
        {{ Batt2 }}%
        <span class="ml-1 mr-3 text-[10px]">({{ TempBatt2 }}°C)</span>
      </span>
    </template>
    <template v-else>
      <span class="text-xs">
        {{ ChargingBatt }}%
      </span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    DroneIsCharging() {
      return this.config?.dock?.status?.drone_charge_state?.state != undefined
        ? this.config.dock.status.drone_charge_state.state == 1
        : false;
    },

    ChargingBatt() {
      return this.config?.dock?.status?.drone_charge_state?.capacity_percent != undefined
        ? this.config?.dock?.status?.drone_charge_state?.capacity_percent
        : ENV.NO_DATA;
    },

    Batt1() {
      return this.config?.drone?.status?.battery?.batteries[0]?.capacity_percent != undefined
        ? this.config.drone.status.battery.batteries[0].capacity_percent
        : ENV.NO_DATA;
    },

    TempBatt1() {
      return this.config?.drone?.status?.battery?.batteries[0]?.temperature != undefined
        ? this.config.drone.status.battery.batteries[0].temperature
        : ENV.NO_DATA;
    },

    Batt2() {
      return this.config?.drone?.status?.battery?.batteries[1]?.capacity_percent != undefined
        ? this.config.drone.status.battery.batteries[1].capacity_percent
        : false;
    },

    TempBatt2() {
      return this.config?.drone?.status?.battery?.batteries[1]?.temperature != undefined
        ? this.config.drone.status.battery.batteries[1].temperature
        : false;
    },

  },
};
</script>
